module.exports = __webpack_public_path__ + "static/media/set.bf6f47ef.svg";